module.exports = __webpack_public_path__ + "static/img/room_titletwo3.a37d89c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_titletwo3.png
// module id = DQcy
// module chunks = 0